import { useCart } from 'lib/core/hooks'
import { useEffect } from 'react'

export const useJustunoConversion = (orderId: string | number) => {
  const { cart } = useCart()
  const cartData = cart?.data

  useEffect(() => {
    // @ts-expect-error
    const juapp: any = window.juapp
    if (!cartData || !juapp) {
      return
    }

    const { amount: shippingAmount } = cartData.shippingAddress?.selectedShippingMethod ?? {}

    juapp('order', `${orderId}`, {
      total: cartData.prices.grandTotal.value,
      subtotal: cartData.prices.subtotalIncludingTax.value,
      tax: cartData.prices.subtotalIncludingTax.value - cartData.prices.subtotalExcludingTax.value,
      shipping: shippingAmount,
      currency: cartData.prices.grandTotal.currency
    })

    cartData.items.forEach(cartItem => {
      juapp('orderItem', `${cartItem.id}`, {
        name: cartItem.product.name,
        quantity: cartItem.quantity,
        price: cartItem.prices.price.value,
        color: '',
        size: ''
      })
    })
    // eslint-disable-next-line
  }, [])

  return null
}
